export const ConflictCode = {
    C01: 'C01',
    C02: 'C02',
    C03: 'C03',
    C04: 'C04',
    C05: 'C05',
    C06: 'C06',
    C07: 'C07',
    C08: 'C08',
    C09: 'C09',
    C10: 'C10',
    C11: 'C11',
    C12: 'C12',
    C13: 'C13',
};
/** Значення в порядку оголошення в схемі. */
export const CONFLICT_CODE_VALUES = ['C01', 'C02', 'C03', 'C04', 'C05', 'C06', 'C07', 'C08', 'C09', 'C10', 'C11', 'C12', 'C13'];
export const CONFLICT_CODE_LABELS = {
    C01: 'Конфлікт груп',
    C02: 'Конфлікт викладача',
    C03: 'Конфлікт аудиторії',
    C04: 'Перевищення місткості',
    C05: 'Неправильний тип аудиторії / обладнання',
    C06: 'Відсутня аудиторія',
    C07: 'Конфлікт корпусів',
    C08: 'Недостатній час переміщення',
    C09: 'Перевищення навантаження',
    C10: 'Невиконання кількості годин',
    C11: 'Відсутність / недоступність викладача',
    C12: 'Накладання дисциплін / порушення плану',
    C13: 'Мова викладання',
};
/** Рівень конфлікту за каталогом SPEC розд. 8 (сервіс конфліктів може підвищити/знизити для окремого випадку). */
export const CONFLICT_CODE_SEVERITY = {
    C01: 'CRITICAL',
    C02: 'CRITICAL',
    C03: 'CRITICAL',
    C04: 'CRITICAL',
    C05: 'HIGH',
    C06: 'HIGH',
    C07: 'HIGH',
    C08: 'CRITICAL',
    C09: 'HIGH',
    C10: 'HIGH',
    C11: 'CRITICAL',
    C12: 'WARNING',
    C13: 'HIGH',
};
//# sourceMappingURL=conflict-code.js.map